import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { QUERY_KEYS } from 'constants/common';
import { PatientService } from 'services/patient';
import { type GetPatientRecordsParams, type PatientRecord } from 'types/patient';

export const useFetchPatientRecords = (
  patientId: string,
  params?: GetPatientRecordsParams
): UseQueryResult<PatientRecord[]> => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_PATIENT_RECORDS, patientId, params?.contractId, params?.status],
    queryFn: async (): Promise<PatientRecord[]> => {
      try {
        const response = await PatientService.getRecords(patientId, params);

        if (response.status === 406) {
          toast.error(t('PatientRecords.error.notInsurance'));
          return [];
        }

        return response.data ?? [];
      } catch (error) {
        if (isAxiosError(error) && error.response?.status === 406) {
          toast.error(t('PatientRecords.error.notInsurance'));
          return [];
        }
        throw error;
      }
    },
    enabled: !!patientId,
  });
};
